import { resolveCompRefWithVariant } from './resolveCompRefWithVariant';
import type { DSRead, CompRef } from 'types/documentServices';

export function responsiveLayoutGet(dsRead: DSRead, compRef: CompRef) {
  const compRefWithVariant = resolveCompRefWithVariant(dsRead, compRef);
  return dsRead.components.responsiveLayout.get(compRefWithVariant);
}
